import React, { useState } from 'react';
import { Button, useViewport } from '@lamimed/pantheon';

import { MarkdownContent } from 'components/MarkdownContent';

import * as S from './styles';

interface Props {
  content: string;
  limit: number;
}

export const ContentSpoiler: React.FC<Props> = ({ limit, content }) => {
  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const { lessThan } = useViewport();

  return (
    <S.Wrapper>
      <MarkdownContent
        content={
          descriptionOpen ? content : `${content.substring(0, limit)}...`
        }
      />

      <S.Fade open={descriptionOpen}>
        <Button
          variant="outline"
          onClick={() => setDescriptionOpen((current) => !current)}
          extended={lessThan('tablet')}
          size="large"
        >
          {descriptionOpen ? 'Vedi meno' : 'Scopri di piu'}
        </Button>
      </S.Fade>
    </S.Wrapper>
  );
};
